import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActiveSessions } from 'src/app/model/activeSessions';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-deviceinfo',
  templateUrl: './deviceinfo.component.html',
  styleUrls: ['./deviceinfo.component.css']
})
export class DeviceinfoComponent implements OnInit {
  currentMDN:string = "";
  Expiration:string;
  LastRecharge: string;
  BillingModel:string;
  BlockStatus:string;
  Balance:string;
  BillingStatus: string ;
  IsOnline:string;
  IsIdle: string;
  AccountMDN:string;
  ProductName:string ;
  SubscriptionCost:string;
  Accountstatus: string;
  showLogin :boolean



  constructor(private route: ActivatedRoute, private accountService:AccountService) {
    
      this.  currentMDN = this.route.snapshot.params.id;
    }

  ngOnInit() {
    
    this.  currentMDN = this.route.snapshot.params.id;

    const obj = {
      i_account: this.  currentMDN 
   
      
    };
    this.accountService.getaccountdetail(obj).subscribe(    
      data => {    
             
        if(data.statusCode=="200")    
        {       
          
         
             ;
            this.Expiration = data.data.expirationDate;
            this .LastRecharge = data.data.activationDate;
            this.BillingModel = data.data.billingModel;
            this.BlockStatus = data.data.blockStatus;
            this.Balance = data.data.serviceType.name =="VOIP"?  data.data.balance:  data.data.dataVolume ;
            this.IsOnline = data.data.onlineStatus;
            const accountState= data.data.accountState;
            this.IsIdle = data.data.idleDays;           
            this.AccountMDN = data.data.accountMDN;
            this . ProductName = data.data.productName;
            this.SubscriptionCost = "₦"+data.data.product.price;

            switch(accountState)
            { 
             case 0: { 
               this.BillingStatus="Blocked";
                break; 
             } 
             case 1: { 
               this.BillingStatus="Active";
                break; 
             } 
             case 2: {
               this.BillingStatus="Zero Balance";
                break;    
             } 
             case 3: { 
               this.BillingStatus="Expired";
                break; 
             }  
             default: { 
               
                break;              
             } 
                 
           }
           this.Accountstatus = this.BillingStatus;
           this.showLogin = data.data.loginCredential==null? true:false;
            
             
        
               
          
         
        }    
        else{   
        

          
              
        //  this.errorMessage = data.Message;    
         // this.alertService.error(this.errorMessage);
        }    
      },    
      error => {    
         
       // this.loading = false;  
        

      //  this.errorMessage = error.message; 
        
     //   this.alertService.error(this.errorMessage); 
      }); 
    




  }

}
